import { z } from 'zod'
import { IntegrationServiceId } from '../../../common/integrations'
import { type ToolUse } from '../../../models/StreamingAIAgent'

const integrationUserActionPayloadSchema = z.object({
  // snake_case on purpose: tool call parameters reach the client as-is, without a DTO
  integration_service_id: z.nativeEnum(IntegrationServiceId),
})

const userActionPayloadSchema = z.discriminatedUnion('type', [
  integrationUserActionPayloadSchema.extend({ type: z.literal('save_document_summary') }),
  integrationUserActionPayloadSchema.extend({ type: z.literal('save_meeting_summary') }),
  integrationUserActionPayloadSchema.extend({ type: z.literal('save_summary_as_pdf_document') }),
  integrationUserActionPayloadSchema.extend({ type: z.literal('save_tasks') }),
  integrationUserActionPayloadSchema.extend({
    type: z.literal('save_contact_details'),
    // snake_case on purpose: tool call parameters reach the client as-is, without a DTO
    contact_id: z.string(),
  }),
])

export type UserActionPayload = z.infer<typeof userActionPayloadSchema>

export const getUserActionPayload = (toolUse: ToolUse): UserActionPayload | null => {
  const result = userActionPayloadSchema.safeParse(toolUse.input?.action)
  return result.success ? result.data : null
}
